
import React from 'react';

interface VisibilityBarsProps {
  rating: number;
  /** Optional; default matches the planner table pips. SharedTrip already passes "sm". */
  size?: 'sm' | 'md';
}

export const VisibilityBars: React.FC<VisibilityBarsProps> = ({ rating, size = 'md' }) => {
  const pipSize = size === 'sm' ? 'w-1.5 h-3' : 'w-2 h-4';
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 10 }, (_, i) => (
        <div
          key={i}
          data-pip={i < rating ? 'on' : 'off'}
          className={`${pipSize} rounded-sm box-border ${
            i < rating
              ? 'bg-galaxy-blue border border-transparent'
              : 'bg-muted border border-muted-foreground/80'
          }`}
        />
      ))}
    </div>
  );
};
